/* Elwardany homepage behaviours: native scroll rails with arrow buttons. */
if (!customElements.get('elw-rail')) {
  customElements.define('elw-rail', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.elw-rail');
      this.btns = [...this.querySelectorAll(':scope > .elw-rail__btn')];
      if (!this.list || this.btns.length < 2) return;
      const rtl = () => getComputedStyle(this).direction === 'rtl';
      this.btns.forEach((b) => b.addEventListener('click', () => {
        const d = Number(b.dataset.dir) * (rtl() ? -1 : 1);
        this.list.scrollBy({ left: d * this.list.clientWidth * 0.9, behavior: 'smooth' });
      }));
      const update = () => {
        const max = this.list.scrollWidth - this.list.clientWidth - 2;
        const pos = Math.abs(this.list.scrollLeft);
        this.btns[0].hidden = pos <= 2;
        this.btns[1].hidden = pos >= max;
      };
      this.list.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(this.list);
      update();
    }
  });
}
